import React, { useState } from "react";
import "./index.css";

function CounsellorModal({ isOpen, onClose }) {
  const [copied, setCopied] = useState(false);
  const phoneNumber = "+91 9522350555";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(phoneNumber);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2 className="modal-heading">Counsellor Details</h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="modal-row">
            <span className="label">Name:</span>
            <span className="value">Akshat Moghe</span>
          </div>
          <div className="modal-row">
            <span className="label">Contact Number:</span>
            <div className="copy-container">
              <span className="value">{phoneNumber}</span>
              <button className="copy-btn" onClick={handleCopy}>
                {copied ? "Copied!" : "Copy"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CounsellorModal;
